import { createContext, type Context } from "react";
import type { AppContext as IAppContext } from "@softr-io/blocks-sdk";

export const AppContext: Context<IAppContext | null> = createContext<IAppContext | null>(null);
